"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div id="app-loader" class="${x => x.block ? 'block' : ''}" style="--indicator-width: ${x => x.indicatorWidth}; --l_width: ${x => x.width}; --l_height: ${x => x.height}"></div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  width: var(--l_width, 60px);
  height: var(--l_height, 60px);
}

:host(.block) {
  position: static;
  top: 0;
  left: 0;
  transform: none;
  display: inline-block;
}

#app-loader {
  width: 100%;
  height: 100%;
  border: var(--indicator-width, 6px) solid #ccc;
  border-top: var(--indicator-width, 6px) solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`;
const shadowOptions = { "mode": "open" };
let LoaderComponent = class LoaderComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.block = false;
        this.height = '60px';
        this.width = '60px';
        this.indicatorWidth = '6px';
    }
    connectedCallback() {
        var _a, _b, _c;
        super.connectedCallback();
        if (this.block) {
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.host.classList.add('block');
            ((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.host).style.width = this.width;
            ((_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.host).style.height = this.height;
        }
    }
    heightChange(oldValue, newValue) {
        if (!oldValue && newValue && !newValue.endsWith('px')) {
            this.height = `${newValue}px`;
        }
    }
    widthChange(oldValue, newValue) {
        if (!oldValue && newValue && !newValue.endsWith('px')) {
            this.width = `${newValue}px`;
        }
    }
};
exports.LoaderComponent = LoaderComponent;
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], LoaderComponent.prototype, "block", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], LoaderComponent.prototype, "height", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], LoaderComponent.prototype, "width", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], LoaderComponent.prototype, "indicatorWidth", void 0);
exports.LoaderComponent = LoaderComponent = __decorate([
    (0, client_1.RWSView)('app-loader', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], LoaderComponent);
LoaderComponent.defineComponent();
